





















import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import homeIconActive from './assets/common/home_a@2x.png';
import homeIcon from './assets/common/home@2x.png';
import cmptIconActive from './assets/common/cmpt_a@2x.png';
import cmptIcon from './assets/common/cmpt@2x.png';
import infoIconActive from './assets/common/info_a@2x.png';
import infoIcon from './assets/common/info@2x.png';
import userIconActive from './assets/common/user_a@2x.png';
import userIcon from './assets/common/user@2x.png';

@Component({
    components: {},
})
export default class App extends Vue {
    @Getter('userInfo') user!: any;

    private navCfg = [
        { name: 'nav-1', to: '/', title: '首页', active: homeIconActive, inactive: homeIcon },
        { name: 'nav-2', to: '/competitions', title: '竞赛', active: cmptIconActive, inactive: cmptIcon },
        { name: 'nav-3', to: '/information', title: '活动', active: infoIconActive, inactive: infoIcon },
        { name: 'nav-4', to: '/users', title: '我的', active: userIconActive, inactive: userIcon },
    ];

    private activeTab = (() => {
        const pathStr = `/${location.pathname.split('/')[1]}`;
        if (pathStr === this.navCfg[0]['to']) {
            return this.navCfg[0]['name'];
        } else if ([this.navCfg[1]['to'], '/special'].includes(pathStr)) {
            return this.navCfg[1]['name'];
        } else if (pathStr === this.navCfg[2]['to']) {
            return this.navCfg[2]['name'];
        } else if (pathStr === this.navCfg[3]['to']) {
            return this.navCfg[3]['name'];
        } else {
            return '';
        }
    })();

    get showTabBar() {
        if (/^\/users\//.test(this.$route.path)) {
            return this.$route.path.split('/').length === 3;
        } else if (/^\/login|^\/register|^\/forget|^\/agreement/.test(this.$route.path)) {
            return false;
        } else {
            return this.$route.path.split('/').length === 2;
        }
    }

    private onClickUser() {
        this.$router.replace(`/users/${this.user.id}`);
    }

    @Watch('activeTab')
    watchValue(name: string) {
        const currentTab: any = this.navCfg.find(item => {
            return item.name === name;
        });
        if (name !== this.navCfg[3]['name']) {
            this.$router.push(currentTab.to);
        } else if (name === this.navCfg[3]['name'] && !this.user.id) {
            this.$router.push('/login?source=/users');
        } else {
            this.$router.push(`/users/${this.user.id}`);
        }
    }
}
